import HeaderBar from "../HeaderBar";
import ContactForm from "./ContactForm";

const ContactUs = () => {
  return (
    <>
      <HeaderBar />
      <ContactForm />
    </>
  );
};

export default ContactUs;
